import { ErrorStateMatcher } from "@angular/material/core";
import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";

/**
 * Error when control is invalid.
 *
 * @see https://material.angular.io/components/input/overview#changing-when-error-messages-are-shown
 */
export class LgdErrorStateMatcher implements ErrorStateMatcher 
{
    isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean 
    {
        return !!(control && control.invalid);
    }
}
